export function convertScanTaskStartDateDbValueToMilliseconds(startDate: {
  date: string;
  hours: number;
  minutes: number;
}): number {
  const milliseconds = new Date(startDate.date);
  return new Date(
    milliseconds.getFullYear(),
    milliseconds.getMonth(),
    milliseconds.getDate(),
    startDate.hours,
    startDate.minutes
  ).getTime();
}
